import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ButtonComponent from './ButtonComponent';
import Card from './Card';
import { useNavigate } from 'react-router-dom';
import Input from './Input';
import { useDropzone } from 'react-dropzone';
import toast from 'react-hot-toast';
import {
  UnauthorizedFunction,
  validateFunction,
} from '../../utils/UtilsFunction';
import { useSelector } from 'react-redux';
import { iconsPath, imagetarget } from '../../utils/imagePath';
import useClickOutside from '../UseClickOutside';
import useFocusTrap from '../../Hooks/useFocusTrap';
import ConfirmDialog, {
  deleteCard,
  duplicateCard,
  renameCard,
} from '../ProjectAction/ProjectAction';

/** Normalize imageTarget_rating API payload (PascalCase or camelCase). */
function normalizeImageRatingResponse(data) {
  if (!data || typeof data !== 'object') {
    return {
      rating: 0,
      grayImagePath: '',
      featureImagePath: '',
      success_Status: false,
    };
  }

  const rating = Number(data.Rating ?? data.rating ?? 0);
  const grayImagePath =
    data.grayImagePath ?? data.gray_image_path ?? data.grayImage ?? '';
  const featureImagePath =
    data.featureImagePath ??
    data.feature_image_path ??
    data.featureImage ??
    '';
  const success_Status = Number.isFinite(rating) && rating > 2;

  return {
    rating,
    Rating: rating,
    grayImagePath,
    featureImagePath,
    success_Status,
  };
}

export const InputGrid = React.memo(
  ({
    type,
    placeholder,
    value,
    onChange,
    label,
    block,
    className,
    onClick,
  }) => {
    return (
      <div className="mr-auto ml-2">
        <label>{label}</label>
        <input
          className={className}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          block={block}
          onClick={onClick}
        />
      </div>
    );
  }
);

// export const CardLayout = React.memo(
//   ({
//     showAll,
//     showAllClick,
//     title,
//     id,
//     cards,
//     buttonText,
//     showName = 'title',
//     onCardSelect,
//     gridClass = ' grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4',
//     cardSize = 'w-full h-[180px]',
//     isCentered = false,
//     initialDisplayCount = 4,
//   }) => {
//     const navigate = useNavigate();
//     const [menuOpen, setMenuOpen] = useState(null);
//     const [editingId, setEditingId] = useState(null);
//     const [newName, setNewName] = useState('');
//     const [cardList, setCardList] = useState(cards);

//     const [showConfirm, setShowConfirm] = useState(false);
//     const [deleteId, setDeleteId] = useState(null);
//     const [deleteName, setDeleteName] = useState('');
//     const dropdownRef = useRef(null);
//     const cancelRenameRef = useRef(false);

//     useClickOutside(dropdownRef, () => {
//       setMenuOpen(null);
//     });

//     const commitRename = useCallback(
//       async (projectId, originalName) => {
//         if (editingId !== projectId) return;

//         const trimmed = newName.trim();
//         setEditingId(null);

//         if (!trimmed || trimmed === (originalName ?? '').trim()) {
//           return;
//         }

//         try {
//           await renameCard(projectId, trimmed);
//           setCardList((prev) =>
//             prev.map((card) =>
//               card._id === projectId ? { ...card, [showName]: trimmed } : card
//             )
//           );
//         } catch {
//           alert('Rename failed');
//         }
//       },
//       [editingId, newName, showName]
//     );

//     const cancelRename = useCallback(() => {
//       cancelRenameRef.current = true;
//       setEditingId(null);
//     }, []);

//     // ✅ Sync cards prop to local state after refresh or update
//     useEffect(() => {
//       setCardList(cards);
//     }, [cards]);

//     const handleCardClick = (v) => {
//       // If callback is provided, use it (for library popup)
//       if (onCardSelect) {
//         onCardSelect(v);
//         return;
//       }

//       if (
//         title === 'Recent' ||
//         title === 'Industry Templates' ||
//         id === 'my_projects'
//       ) {
//         window.location.reload();
//         navigate(`/gridpage/${v?._id}`);
//         window.location.reload();
//       }
//     };

//     return (
//       <>
//         {cardList?.length > 0 && (
//           <div className="flex flex-col gap-4">
//             <div className="flex justify-between">
//               <h1 className="text-[#979797]">{title}</h1>
//               {buttonText && cardList?.length > initialDisplayCount && (
//                 <ButtonComponent
//                   className="!min-w-[80px] max-w-[64px] text-[12px] text-nowrap !h-[20px] flex items-center justify-center !rounded-[50px] bg-[#333539] text-[#8D8C8C]"
//                   onClick={showAllClick}
//                 >
//                   <p className="text-[#8D8C8C]">{buttonText}</p>
//                 </ButtonComponent>
//               )}
//             </div>
//             <div className={`grid gap-4 ${gridClass}`}>
//               {(showAll
//                 ? cardList
//                 : cardList.slice(0, initialDisplayCount)
//               ).map((v, index) => (
//                 <div
//                   key={index}
//                   className="flex flex-col gap-1 items-center"
//                   onClick={() => {
//                     if (editingId === v._id) return;
//                     handleCardClick(v);
//                   }}
//                 >
//                   <div
//                     className={`overflow-hidden rounded-[6px] cursor-pointer hover:opacity-80 transition-opacity ${cardSize}`}
//                   >
//                     <img
//                       className="object-cover w-full h-full border-[1px] border-transparent hover:border-[#EE2B2A] rounded-[6px] transition-all duration-200"
//                       src={`${v?.th_image_url || v?.thumbnail}`}
//                       alt={v?.alt || 'thumbnail'}
//                       onError={(e) => {
//                         e.currentTarget.onerror = null; // prevent infinite loop
//                         e.currentTarget.src =
//                           'https://spatialgrid-uploads.s3.ap-south-1.amazonaws.com/uploads/library-assets/default-surface-thumbnail.png';
//                       }}
//                     />
//                   </div>

//                   {(v[showName] || v.name || v.title) && (
//                     <div
//                       className={`flex items-center ${isCentered ? 'justify-start' : 'justify-between'} ${isCentered ? 'pl-2' : 'pl-2 pr-2'} relative group ${isCentered ? 'w-[150px]' : 'w-full'}`}
//                     >
//                       {editingId === v._id ? (
//                         <input
//                           className={`text-xs sm:text-sm px-2 py-[2px] sm:px-3 sm:py-[4px] rounded border border-[#EE2B2A] bg-[#1E1F22]
//                            text-white w-full ${isCentered ? '' : ''} ${isCentered ? '' : 'max-w-[180px]'} focus:outline-none focus:ring-1 focus:ring-[#EE2B2A]`}
//                           value={newName}
//                           onChange={(e) => setNewName(e.target.value)}
//                           onClick={(e) => e.stopPropagation()}
//                           onBlur={() => {
//                             if (cancelRenameRef.current) {
//                               cancelRenameRef.current = false;
//                               return;
//                             }
//                             commitRename(v._id, v[showName]);
//                           }}
//                           onKeyDown={async (e) => {
//                             if (e.key === 'Enter') {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               await commitRename(v._id, v[showName]);
//                             } else if (e.key === 'Escape') {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               cancelRename();
//                             }
//                           }}
//                           autoFocus
//                         />
//                       ) : (
//                         // <span
//                         //   className="text-[15px] text-[#BCBCBC] truncate max-w-[200px]"
//                         //   title={`${v[showName]}${v?.category ? ` (${v.category})` : ''}`}
//                         // >
//                         //   {v[showName]}{' '}
//                         //   {/* {v?.category &&
//                         //     `(${v.category.charAt(0).toUpperCase() + v.category.slice(1).toLowerCase()})`} */}
//                         //     {v?.category && `(${v.category.toUpperCase()})`}

//                         // </span>

//                         <span
//                           className={`text-[15px] text-[#BCBCBC] truncate ${isCentered ? '' : ''} ${isCentered ? '' : 'max-w-[200px]'}`}
//                           title={
//                             v?.category === 'VR'
//                               ? `${v[showName] || v.name || v.title} (VR)`
//                               : v?.category &&
//                                 ['SURFACE', 'WORLD', 'VPS'].includes(v.category)
//                                 ? `${v[showName] || v.name || v.title} (AR-${v.category})`
//                                 : v[showName] || v.name || v.title
//                           }
//                         >
//                           {v[showName] || v.name || v.title}{' '}
//                           {v?.category === 'VR'
//                             ? '(VR)'
//                             : v?.category &&
//                               ['SURFACE', 'WORLD', 'VPS'].includes(v.category)
//                               ? `(AR-${v.category})`
//                               : v?.category
//                                 ? `(${v.category})`
//                                 : ''}
//                         </span>
//                       )}

//                       {(title === 'Recent' ||
//                         title === 'Industry Templates' ||
//                         id === 'my_projects') && (
//                           <img
//                             src={iconsPath?.verticalThreeDots}
//                             alt="menu"
//                             className="w-5 h-5 cursor-pointer"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setMenuOpen(v._id === menuOpen ? null : v._id);
//                             }}
//                           />
//                         )}

//                       {menuOpen === v._id && (
//                         <div
//                           className="absolute right-2 top-full mt-1 w-36 bg-[#1E1F22] rounded-md shadow-lg z-50"
//                           onClick={(e) => e.stopPropagation()}
//                           ref={dropdownRef}
//                         >
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               cancelRenameRef.current = false;
//                               setEditingId(v._id);
//                               setNewName(v[showName]);
//                               setMenuOpen(null);
//                             }}
//                             className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#333]"
//                           >
//                             Rename
//                           </button>
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               setDeleteId(v._id);
//                               setDeleteName(v[showName]);
//                               setShowConfirm(true);
//                               setMenuOpen(null);
//                             }}
//                             className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#333]"
//                           >
//                             Delete
//                           </button>
//                           <button
//                             onClick={async (e) => {
//                               e.stopPropagation();
//                               try {
//                                 const newCard = await duplicateCard(v._id);
//                                 if (newCard?.data) {
//                                   setCardList((prev) => [
//                                     newCard.data,
//                                     ...prev,
//                                   ]);
//                                 }
//                                 setMenuOpen(null);
//                               } catch (error) {
//                                 console.error('Error duplicating card:', error);
//                               }
//                             }}
//                             className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#333]"
//                           >
//                             Duplicate
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <ConfirmDialog
//           open={showConfirm}
//           onClose={() => setShowConfirm(false)}
//           onConfirm={async () => {
//             try {
//               await deleteCard(deleteId);
//               setCardList((prev) =>
//                 prev.filter((card) => card._id !== deleteId)
//               );
//               setShowConfirm(false);
//             } catch (err) {
//               alert('Delete failed');
//             }
//           }}
//           message={`Are you sure you want to delete "${deleteName}"? This action cannot be undone.`}
//         />
//       </>
//     );
//   }
// );
export const CardLayout = React.memo(
  ({
    showAll,
    showAllClick,
    title,
    id,
    cards,
    buttonText,
    showName = 'title',
    onCardSelect,
    gridClass = ' grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4',
    cardSize = 'w-full h-[180px]',
    isCentered = false,
    initialDisplayCount = 4,
    showLibraryMeta = false,
  }) => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [newName, setNewName] = useState('');
    const [cardList, setCardList] = useState(cards);

    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteName, setDeleteName] = useState('');
    const dropdownRef = useRef(null);
    const cancelRenameRef = useRef(false);

    useClickOutside(dropdownRef, () => {
      setMenuOpen(null);
    });

    const commitRename = useCallback(
      async (projectId, originalName) => {
        if (editingId !== projectId) return;

        const trimmed = newName.trim();
        setEditingId(null);

        if (!trimmed || trimmed === (originalName ?? '').trim()) {
          return;
        }

        try {
          await renameCard(projectId, trimmed);
          setCardList((prev) =>
            prev.map((card) =>
              card._id === projectId ? { ...card, [showName]: trimmed } : card
            )
          );
        } catch {
          alert('Rename failed');
        }
      },
      [editingId, newName, showName]
    );

    const cancelRename = useCallback(() => {
      cancelRenameRef.current = true;
      setEditingId(null);
    }, []);

    // ✅ Sync cards prop to local state after refresh or update
    useEffect(() => {
      setCardList(cards);
    }, [cards]);

    const handleCardClick = (v) => {
      // If callback is provided, use it (for library popup)
      if (onCardSelect) {
        onCardSelect(v);
        return;
      }

      if (
        title === 'Recent' ||
        title === 'Industry Templates' ||
        id === 'my_projects'
      ) {
        window.location.reload();
        navigate(`/gridpage/${v?._id}`);
        window.location.reload();
      }
    };

    return (
      <>
        {cardList?.length > 0 && (
          <div className="flex flex-col">
            <div className="flex justify-between">
              <h1 className="text-[#979797]">{title}</h1>
              {buttonText && cardList?.length > initialDisplayCount && (
                <ButtonComponent
                  className="!min-w-[80px] max-w-[64px] text-[12px] text-nowrap !h-[20px] flex items-center justify-center !rounded-[50px] bg-[#333539] text-[#8D8C8C]"
                  onClick={showAllClick}
                >
                  <p className="text-[#8D8C8C]">{buttonText}</p>
                </ButtonComponent>
              )}
            </div>
            <div className={`grid gap-4 ${gridClass}`}>
              {(showAll
                ? cardList
                : cardList.slice(0, initialDisplayCount)
              ).map((v, index) => (
                <div
                  key={index}
                  className={`${showLibraryMeta ? '' : 'flex flex-col gap-1 items-center'}`}
                  onClick={() => {
                    if (editingId === v._id) return;
                    handleCardClick(v);
                  }}
                >
                  {showLibraryMeta ? (
                    /* ── Library card: image area + solid bottom text section ── */
                    <div
                      className={`relative flex flex-col overflow-hidden rounded-[12px] cursor-pointer bg-[#1c1c1f] border border-[#2a2a2e] hover:border-[#EE2B2A] transition-all duration-200 ${cardSize}`}
                    >
                      {/* image zone — takes ~70% height, image contained with padding */}
                      <div className="flex-1 overflow-hidden p-3">
                        <div className="w-full h-full rounded-[8px] overflow-hidden">
                        <img
                          className="w-full h-full object-cover"
                          src={v?.th_image_url || v?.thumbnail || v?.streamUrl}
                          alt={v?.alt || v?.name || 'thumbnail'}
                          onError={(e) => {
                            // try streamUrl as secondary fallback before the default placeholder
                            if (e.currentTarget.src !== v?.streamUrl && v?.streamUrl) {
                              e.currentTarget.src = v.streamUrl;
                            } else {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src =
                                'https://spatialgrid-uploads.s3.ap-south-1.amazonaws.com/uploads/library-assets/default-surface-thumbnail.png';
                            }
                          }}
                        />
                        </div>
                      </div>
                      {/* solid bottom text section */}
                      <div className="flex-shrink-0 px-3 pb-3 pt-1 flex flex-col gap-0.5 border-[#2a2a2e]">
                        <span className="text-[14px] font-semibold text-white truncate leading-tight">
                          {v[showName] || v.name || v.title}
                        </span>
                        {(v?.metadata?.polyCount != null || v?.metadata?.fileSize != null) && (
                          <div className="flex items-center gap-1">
                            {v?.metadata?.polyCount != null && (
                              <span className="text-[12px] text-[#888]">
                                {v.metadata.polyCount >= 1000
                                  ? `${Math.round(v.metadata.polyCount / 1000)}K Poly`
                                  : `${v.metadata.polyCount} Poly`}
                              </span>
                            )}
                            {v?.metadata?.polyCount != null && v?.metadata?.fileSize != null && (
                              <span className="text-[12px] text-[#555]">•</span>
                            )}
                            {v?.metadata?.fileSize != null && (
                              <span className="text-[12px] text-[#888]">
                                {v.metadata.fileSize >= 1073741824
                                  ? `${(v.metadata.fileSize / 1073741824).toFixed(1)} GB`
                                  : v.metadata.fileSize >= 1048576
                                    ? `${Math.round(v.metadata.fileSize / 1048576)} MB`
                                    : `${Math.round(v.metadata.fileSize / 1024)} KB`}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    /* ── Default card (all other pages) ── */
                    <>
                  <div
                    className={`overflow-hidden rounded-[6px] cursor-pointer hover:opacity-80 transition-opacity ${cardSize}`}
                  >
                    <img
                      className="object-cover w-full h-full border-[1px] border-transparent hover:border-[#EE2B2A] rounded-[6px] transition-all duration-200"
                      src={v?.th_image_url || v?.thumbnail}
                      alt={v?.alt || 'thumbnail'}
                      onError={(e) => {
                        e.currentTarget.onerror = null; // prevent infinite loop
                        e.currentTarget.src =
                          'https://spatialgrid-uploads.s3.ap-south-1.amazonaws.com/uploads/library-assets/default-surface-thumbnail.png';
                      }}
                    />
                  </div>

                  {(v[showName] || v.name || v.title) && (
                    <div
                      className={`flex flex-col ${isCentered ? 'items-start pl-2' : 'pl-2 pr-2'} relative group ${isCentered ? 'w-[150px]' : 'w-full'}`}
                    >
                      <div className={`flex items-center ${isCentered ? 'justify-start' : 'justify-between'} w-full`}>
                      {editingId === v._id ? (
                        <input
                          className={`text-xs sm:text-sm px-2 py-[2px] sm:px-3 sm:py-[4px] rounded border border-[#EE2B2A] bg-[#1E1F22]
                           text-white w-full ${isCentered ? '' : ''} ${isCentered ? '' : 'max-w-[180px]'} focus:outline-none focus:ring-1 focus:ring-[#EE2B2A]`}
                          value={newName}
                          onChange={(e) => setNewName(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          onBlur={() => {
                            if (cancelRenameRef.current) {
                              cancelRenameRef.current = false;
                              return;
                            }
                            commitRename(v._id, v[showName]);
                          }}
                          onKeyDown={async (e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              e.stopPropagation();
                              await commitRename(v._id, v[showName]);
                            } else if (e.key === 'Escape') {
                              e.preventDefault();
                              e.stopPropagation();
                              cancelRename();
                            }
                          }}
                          autoFocus
                        />
                      ) : (
                        // <span
                        //   className="text-[15px] text-[#BCBCBC] truncate max-w-[200px]"
                        //   title={${v[showName]}${v?.category ?  (${v.category}) : ''}}
                        // >
                        //   {v[showName]}{' '}
                        //   {/* {v?.category &&
                        //     (${v.category.charAt(0).toUpperCase() + v.category.slice(1).toLowerCase()})} */}
                        //     {v?.category && (${v.category.toUpperCase()})}

                        // </span>

                        <span
                          className={`text-[15px] text-[#BCBCBC] truncate ${isCentered ? '' : ''} ${isCentered ? '' : 'max-w-[200px]'}`}
                          title={
                            v?.category?.toUpperCase() === 'VR'
                              ? `${v[showName] || v.name || v.title} (VR)`
                              : v?.category?.toUpperCase() === 'FOOT'
                                ? `${v[showName] || v.name || v.title} (ar-body-foot)`
                                : v?.category &&
                                  ['SURFACE', 'WORLD', 'VPS'].includes(v?.category?.toUpperCase())
                                  ? `${v[showName] || v.name || v.title} (AR-${v.category?.toUpperCase()})`
                                  : v[showName] || v.name || v.title
                          }
                        >
                          {v[showName] || v.name || v.title}{' '}
                          {v?.category?.toUpperCase() === 'VR'
                            ? '(VR)'
                            : v?.category?.toUpperCase() === 'FOOT'
                              ? '(ar-body-foot)'
                              : v?.category &&
                                ['SURFACE', 'WORLD', 'VPS'].includes(v?.category?.toUpperCase())
                                ? `(AR-${v.category?.toUpperCase()})`
                                : v?.category
                                  ? `(${v.category})`
                                  : ''}
                        </span>
                      )}

                      {(title === 'Recent' ||
                        title === 'Industry Templates' ||
                        id === 'my_projects') && (
                          <img
                            src={iconsPath?.verticalThreeDots}
                            alt="menu"
                            className="w-5 h-5 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              setMenuOpen(v._id === menuOpen ? null : v._id);
                            }}
                          />
                        )}

                      {menuOpen === v._id && (
                        <div
                          className="absolute right-2 top-full mt-1 w-36 bg-[#1E1F22] rounded-md shadow-lg z-50"
                          onClick={(e) => e.stopPropagation()}
                          ref={dropdownRef}
                        >
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              cancelRenameRef.current = false;
                              setEditingId(v._id);
                              setNewName(v[showName]);
                              setMenuOpen(null);
                            }}
                            className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#333]"
                          >
                            Rename
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeleteId(v._id);
                              setDeleteName(v[showName]);
                              setShowConfirm(true);
                              setMenuOpen(null);
                            }}
                            className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#333]"
                          >
                            Delete
                          </button>
                          <button
                            onClick={async (e) => {
                              e.stopPropagation();
                              try {
                                const newCard = await duplicateCard(v._id);
                                if (newCard?.data) {
                                  setCardList((prev) => [
                                    newCard.data,
                                    ...prev,
                                  ]);
                                }
                                setMenuOpen(null);
                              } catch (error) {
                                console.error('Error duplicating card:', error);
                              }
                            }}
                            className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-[#333]"
                          >
                            Duplicate
                          </button>
                        </div>
                      )}
                      </div>
                      {showLibraryMeta && (v?.metadata?.polyCount || v?.metadata?.fileSize) && (
                        <div className="flex items-center gap-1 mt-0.5">
                          {v?.metadata?.polyCount != null && (
                            <span className="text-[11px] text-[#888]">
                              {v.metadata.polyCount >= 1000
                                ? `${Math.round(v.metadata.polyCount / 1000)}K Poly`
                                : `${v.metadata.polyCount} Poly`}
                            </span>
                          )}
                          {v?.metadata?.polyCount != null && v?.metadata?.fileSize != null && (
                            <span className="text-[11px] text-[#555]">•</span>
                          )}
                          {v?.metadata?.fileSize != null && (
                            <span className="text-[11px] text-[#888]">
                              {v.metadata.fileSize >= 1073741824
                                ? `${(v.metadata.fileSize / 1073741824).toFixed(1)} GB`
                                : v.metadata.fileSize >= 1048576
                                  ? `${Math.round(v.metadata.fileSize / 1048576)} MB`
                                  : `${Math.round(v.metadata.fileSize / 1024)} KB`}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <ConfirmDialog
          open={showConfirm}
          onClose={() => setShowConfirm(false)}
          onConfirm={async () => {
            try {
              await deleteCard(deleteId);
              setCardList((prev) =>
                prev.filter((card) => card._id !== deleteId)
              );
              setShowConfirm(false);
            } catch (err) {
              alert('Delete failed');
            }
          }}
          message={`Are you sure you want to delete "${deleteName}"? This action cannot be undone.`}
        />
      </>
    );
  }
);

export const DashboardContainer = React.memo(({ children }) => {
  return (
    <div className="bg-[#121316] h-[calc(100vh-68px)]  overflow-auto w-full homepage-scrollbar  ">
      <div
        // className="px-[4%] py-[2%] lg:py-[40px] flex flex-col gap-10 "
        className="px-[2%] lg:px-[40px] py-[2%] lg:py-[20px] flex flex-col gap-10 h-full w-full "
      >
        {children}
      </div>
    </div>
  );
});

export const RightIcon = React.memo(({ open, onClick, className }) => {
  return (
    <span
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      className={`ml-2 ${className}`}
    >
      <img
        src={iconsPath?.rightIcon}
        className={`transform transition-transform ${open ? 'rotate-90' : 'rotate-0'
          }`}
        alt="Right Icon"
      />
    </span>
  );
});

export const MyProjectDropDown = React.memo(({ value, options, onChange }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative w-40  md:w-56 dropdown" ref={dropdownRef}>
      <button
        className="text-[13px] w-full flex justify-between items-center px-4 py-2 rounded-[5px] bg-[#31333A]"
        onClick={(e) => {
          e.stopPropagation(); // Prevent closing immediately
          setOpen((prev) => !prev);
        }}
      >
        <span>{value}</span>
        {/* <span className="ml-2">
          <FaChevronRight
            size={15}
            className={`transform transition-transform ${
              open ? "rotate-90" : "rotate-0"
            }`}
          />
        </span> */}

        <RightIcon open={open} />
      </button>

      {open && (
        <div className="absolute w-full mt-1 border border-gray-600 rounded-md shadow-md bg-[#31333A] z-10">
          {options.map((option, index) => (
            <div
              key={index}
              className="text-[13px] px-4 py-2 cursor-pointer hover:bg-[#444447]"
              onClick={() => {
                onChange(option);
                setOpen(false);
              }}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

export const CloseIcon = React.memo(({ closeModal, className }) => {
  return (
    <>
      {closeModal && (
        <button
          onClick={closeModal}
          className={`hover:scale-110 hover:transition  top-3 right-3 h-[30px] w-[30px] rounded-full bg-[#31333A] p-[2px] text-white text-[20px] flex justify-center items-center ${className}`}
        >
          <img src={iconsPath.closeIcon} alt="close Icon" />
        </button>
      )}
    </>
  );
});

export const AddNewProject = React.memo(
  ({ closeModal, title, setIsVisible, goBack, onProjectCreated }) => {
    const [addData, setAddData] = useState({
      markerType: 'single',
      targetType: 'flat',
    });
    const [loading, setLoading] = useState(false);
    const { token } = useSelector((state) => state.user);
    const navigate = useNavigate();
    const modelRef = useRef(null);
    // Add this above return (inside AddNewProject)
    const fileUploadRef = useRef(null);

    // Button refs for focus trap
    const cancelButtonRef = useRef(null);
    const startButtonRef = useRef(null);
    const projectNameRef = useRef(null);
    const commentRef = useRef(null);

    // ADD THIS LINE HERE - right after modelRef
    const throttleRef = useRef(false);

    const handleProjectNameKeyDown = useCallback(
      (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();

        const errors = validateFunction(addData, ['project_name']);
        if (addData.project_name && addData.project_name.trim().length < 3) {
          errors.project_name_err =
            'Project name must be at least 3 characters.';
        }
        if (Object.keys(errors).length > 0) {
          setAddData((prev) => ({ ...prev, ...errors }));
          if (errors.project_name_err) {
            toast.error(errors.project_name_err);
          }
          return;
        }

        if (title === 'Image Target') {
          startButtonRef.current?.focus();
        } else {
          commentRef.current?.focus();
        }
      },
      [title, addData]
    );

    const handleCommentKeyDown = useCallback((e) => {
      if (e.key !== 'Enter' || e.shiftKey) return;
      e.preventDefault();
      startButtonRef.current?.focus();
    }, []);

    // Focus trap: Tab cycles between Cancel and Start Project, Escape closes
    useFocusTrap(
      true,
      closeModal,
      cancelButtonRef,
      startButtonRef,
      projectNameRef
    );

    const handleClickOutside = (event) => {
      if (modelRef.current && !modelRef.current.contains(event.target)) {
        closeModal();
      }
    };

    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    const handleChange = useCallback((value, key, okey1, okey2) => {
      setAddData((prevData) => ({
        ...prevData,
        [key]: value,
        [`${key}_err`]: '',
        [okey1]: '',
        [okey2]: '',
      }));
    }, []);

    // REPLACE YOUR ENTIRE add_project FUNCTION WITH THIS:
    const add_project = useCallback(async () => {
      console.log("Creating project with title/type:", title);
      if (throttleRef.current) {
        toast.error('Please wait before clicking again', { id: 'throttle' });
        return;
      }

      const errors = validateFunction(addData, ['project_name']);
      if (addData.project_name && addData.project_name.trim().length < 3) {
        errors.project_name_err = 'Project name must be at least 3 characters.';
      }

      if (Object.keys(errors).length > 0) {
        setAddData((prevData) => ({
          ...prevData,
          ...errors,
        }));
        if (errors.project_name_err) {
          projectNameRef.current?.focus();
          toast.error(errors.project_name_err);
        }
        return;
      }

      throttleRef.current = true;
      setTimeout(() => {
        throttleRef.current = false;
      }, 3000);

      try {
        setLoading(true);

        let endpoint;
        let headers;
        let body;

        if (title === 'Location-Based AR (VPS)') {
          endpoint = 'experience/create-with-zip';
          body = new FormData();
          body.append('project_name', addData?.project_name);
          body.append('comment', addData?.comment);
          body.append('zipContent', addData?.file);
          headers = {
            Authorization: `Bearer ${token}`,
          };
        } else if (title === 'Image Target') {
          // Use surface/create endpoint with category IMAGE, do not send image file
          const bodyJson = {
            project_name: addData?.project_name,
            comment: addData?.comment,
            category: 'IMAGE',
          };
          endpoint = 'experience/surface/create';
          body = JSON.stringify(bodyJson);
          headers = {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          };
        } else {
          // For other types, use JSON
          const bodyJson = {
            project_name: addData?.project_name,
            comment: addData?.comment,
          };
          if (title === 'Surface Target') {
            endpoint = 'experience/surface/create';
          } else if (title === 'World Tracking') {
            endpoint = 'experience/world/create';
          } else if (title === 'Foot Tracking') {
            endpoint = 'experience';
            bodyJson.category = 'FOOT';
            bodyJson.experience_type = 'immersal';
            bodyJson.experience_sdk = 'immersal';
          } else if (title === 'Virtual Reality') {
            endpoint = 'experience';
            bodyJson.category = 'VR';
            bodyJson.experience_type = 'immersal';
            bodyJson.experience_sdk = 'immersal';
          } else if (title === 'Mixed Reality') {
            endpoint = 'experience';
            bodyJson.category = 'MR';
            bodyJson.experience_type = 'immersal';
            bodyJson.experience_sdk = 'immersal';
          } else if (title === 'Extended Reality') {
            endpoint = 'experience';
            bodyJson.category = 'XR';
            bodyJson.experience_type = 'immersal';
            bodyJson.experience_sdk = 'immersal';
          }
          body = JSON.stringify(bodyJson);
          headers = {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          };
        }

        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}${endpoint}`,
          {
            method: 'POST',
            headers,
            body,
          }
        );

        const res = await response.json();
        console.log("Project creation response:", res);

        if (res.success) {
          // For Image Target, upload the image file to the new project using bulk asset API
          if (title === 'Image Target' && addData?.file) {
            try {
              const projectId = res?.data?._id;
              const assetForm = new FormData();
              assetForm.append('projectId', projectId);
              // Minimal asset metadata, can be extended as needed
              assetForm.append(
                'assets',
                JSON.stringify([
                  {
                    name: addData?.file?.name,
                    description: 'Image Target Marker',
                  },
                ])
              );
              assetForm.append('files', addData.file);
              await fetch(
                `${process.env.REACT_APP_BASE_URL}assets/image/bulk`,
                {
                  method: 'POST',
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                  body: assetForm,
                }
              );
            } catch (assetErr) {
              toast.error('Image upload failed, but project was created.');
            }
          }
          setAddData({});

          if (onProjectCreated) {
            // Called from Library "Add to Project" modal — let the parent
            // handle navigation so it can carry the pending asset in router state.
            onProjectCreated(res.data);
          } else {
            // Normal Dashboard flow — navigate and reload.
            navigate(`/gridpage/${res?.data?._id}`, { replace: true });
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        } else {
          UnauthorizedFunction(res);
          toast.error(res?.message, { id: 1 });
        }
      } catch (error) {
        console.error('Error during API call:', error);
      } finally {
        setLoading(false);
      }
    }, [addData, title, token, navigate, onProjectCreated]);

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center  px-4">
        <div
          ref={modelRef}
          className="relative flex flex-col gap-5 rounded-[10px] w-fit md:min-w-[550px] sm:min-w-[400px] xl:max-w-[800px] xl:min-w-[700px] bg-[#131418] px-10 py-6 
    max-h-[calc(100vh-40px)] "
        >
          <div className="flex justify-between items-center">
            <label className="text-white font-bold">Create a New Project</label>
            <CloseIcon closeModal={closeModal} />
          </div>
          <div className="overflow-y-scroll scrollbar-none flex flex-col gap-2">
            {title === 'Virtual Reality' ||
              title === 'Mixed Reality' ||
              title === 'Extended Reality' ? (
              <Brodcrumb
                data={{
                  name: title === 'Mixed Reality' ? 'Mixed Reality (Beta)' : title,
                  item: [],
                }}
              />
            ) : (
              <div className="flex items-center gap-2 mb-4 font-medium text-md text-[#9F9F9F]">
                <button
                  type="button"
                  className="text-[#D9D9D9] hover:underline focus:outline-none bg-transparent border-none p-0 cursor-pointer"
                  onClick={goBack ? goBack : () => setIsVisible(false)}
                >
                  Augmented Reality
                </button>
                <span className="mx-1">{'>'}</span>
                {title === 'Foot Tracking' ? (
                  <>
                    <button
                      type="button"
                      className="text-[#D9D9D9] hover:underline focus:outline-none bg-transparent border-none p-0 cursor-pointer"
                      onClick={goBack ? goBack : () => setIsVisible(false)}
                    >
                      Body Tracking
                    </button>
                    <span className="mx-1">{'>'}</span>
                  </>
                ) : null}
                <span className="text-[#D9D9D9]">{title}</span>
              </div>
            )}
            <div className="flex flex-col md:flex-row gap-5 ">
              <div className="flex flex-col gap-3 flex-1 ">
                <Input
                  ref={projectNameRef}
                  disabled={loading}
                  value={addData?.project_name}
                  onChange={(e) => {
                    if (e.target.value.length <= 50) {
                      handleChange(e.target.value, 'project_name');
                    }
                  }}
                  onKeyDown={handleProjectNameKeyDown}
                  type="text"
                  placeholder="Enter your project name (Max 50 characters)"
                  className={`min-w-full bg-[#4A4A50] text-white rounded-[5px] p-3 
              text-[13px] font-inter font-normal focus:outline-none border-2 transition-all 
              ${addData?.project_name_err
                      ? 'border-red-500 placeholder:text-red-500 focus:border-blue-500 focus:placeholder:text-[#8A8888]'
                      : 'border-gray-300 placeholder:text-[#8A8888] focus:border-blue-500'
                    }`}
                />
                <div className="text-right text-[12px] text-gray-400">
                  {addData?.project_name?.length || 0}/50
                </div>
                {title === 'Image Target' ? (
                  <div className="space-y-4">
                    {/* Marker Type Selection */}
                    <h2 className="text-[14px] font-semibold mb-2 text-[#979797]">
                      Choose a marker type
                    </h2>
                    <div className="flex gap-4">
                      <div className="flex items-center gap-3 cursor-pointer">
                        <div className="w-4 h-4 rounded-full border-2 border-[#EE2B2A] flex items-center justify-center">
                          {(!addData?.markerType ||
                            addData?.markerType === 'single') && (
                              <div className="w-2 h-2 rounded-full bg-[#EE2B2A]"></div>
                            )}
                        </div>
                        <span className="text-[12px] font-medium text-white">
                          Single Marker
                        </span>
                      </div>

                      <div className="flex items-center gap-3 cursor-pointer">
                        <div className="w-4 h-4 rounded-full border-2 border-gray-400 flex items-center justify-center">
                          {/* <div className="w-2 h-2 rounded-full bg-gray-400"></div> */}
                        </div>
                        <span className="text-[12px] font-medium text-gray-300">
                          Multi-Marker
                        </span>
                      </div>
                    </div>

                    {/* Target Type Selection */}
                    <div>
                      <h2 className="text-[14px] font-semibold mb-6 text-[#979797]">
                        Choose a target type
                      </h2>
                      <div className="grid grid-cols-3 gap-6">
                        {/* Flat Target */}
                        <div className="relative bg-[#1E1F22] rounded-xl p-6 cursor-pointer border-2 border-[#EE2B2A]">
                          <div className="flex flex-col items-center text-center">
                            <div className="w-8 h-8 mb-4">
                              <img src={imagetarget?.type3} alt="Flat" />
                            </div>
                            <span className="text-[12px] font-medium text-white">
                              Flat
                            </span>
                          </div>
                        </div>

                        {/* Cylinder Target */}

                        <div className="relative bg-[#1E1F22] rounded-xl p-6 cursor-not-allowed">
                          {/* Coming soon badge */}
                          <div className="absolute -top-2 right-3 bg-[#2A2A2A] text-[#979797] text-[10px] px-3 py-1 rounded-full shadow">
                            Coming soon
                          </div>
                          <div className="flex flex-col items-center text-center opacity-60">
                            <div className="w-8 h-8 mb-4">
                              <img src={imagetarget?.type2} alt="Cylinder" />
                            </div>
                            <span className="text-[12px] font-medium text-gray-400">
                              Cylinder
                            </span>
                          </div>
                        </div>

                        {/* Cone Target */}
                        <div className="relative bg-[#1E1F22] rounded-xl p-6 cursor-not-allowed">
                          {/* Coming soon badge */}
                          <div className="absolute -top-2 right-3 bg-[#2A2A2A] text-[#979797] text-[10px] px-3 py-1 rounded-full shadow">
                            Coming soon
                          </div>
                          <div className="flex flex-col items-center text-center opacity-60">
                            <div className="w-8 h-8 mb-4">
                              <img src={imagetarget?.type1} alt="Cone" />
                            </div>
                            <span className="text-[12px] font-medium text-gray-400">
                              Cone
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Input
                    ref={commentRef}
                    disabled={loading}
                    value={addData?.comment}
                    onChange={(e) => handleChange(e.target.value, 'comment')}
                    onKeyDown={handleCommentKeyDown}
                    area
                    rows={12}
                    type="textarea"
                    placeholder="Comments"
                    className="min-w-full bg-[#4A4A50] resize-none overflow-hidden text-white rounded-[5px] p-3 placeholder:text-[#8A8888] text-[13px] font-inter font-normal focus:outline-none"
                  />
                )}
              </div>

              {(title === 'Location-Based AR (VPS)' ||
                title === 'Image Target') && (
                  <div
                    className={`min-h-[200px] lg:min-w-auto flex-1 border-dashed border-[3px] rounded-[10px] flex flex-col justify-center items-center text-[#CBCBCB] font-bold hover:bg-[#2a2c30] hover:border-[#fff] transition cursor-pointer  ${addData?.file_err ? 'border-red-500' : 'border-[#31333A]'
                      }`}
                    onClick={() =>
                      fileUploadRef.current && fileUploadRef.current()
                    }
                  >
                    {/* Location-Based AR (VPS) UI */}
                    {title === 'Location-Based AR (VPS)' && (
                      <>
                        {/* Icon */}
                        <div className="mb-4">
                          <img
                            src={iconsPath?.vpsZip}
                            alt="Upload Icon"
                            className="w-20 h-20 object-contain"
                          />
                        </div>

                        {/* Title */}
                        <h3 className="text-[#DEDEDE] text-[14px] font-bold mb-2">
                          Upload an image or drag & drop it here.
                        </h3>

                        {/* Description */}
                        <p className="text-[#DEDEDE] text-[12px] mb-4 text-center max-w-md px-4 font-normal">
                          Only ZIP files are allowed. The ZIP file must contain a
                          .glb and a .json file. <br /> Maximum file size: 100MB.
                        </p>

                        {/* Show selected file name if file is selected */}
                        {/* {addData?.file && (
                        <div className="text-sm mb-4 text-center">
                          <span className="text-gray-400">
                            Selected file: {addData?.file?.name}
                          </span>
                        </div>
                      )} */}

                        {/* Show error message if there's an error */}
                        {addData?.file_err && (
                          <div className="text-sm mb-4 text-center">
                            <span className="text-red-500">
                              {addData.file_err}
                            </span>
                          </div>
                        )}

                        {/* FileUploader Button */}
                        <FileUploader
                          fullAreaClick={fileUploadRef} // 👈 enables parent click trigger
                          disabled={loading}
                          // isVps
                          filename={addData?.file?.name}
                          label="Upload an Asset"
                          accept={{ 'application/zip': ['.zip'] }}
                          onFileSelect={async (file) => {
                            if (file) {
                              const allowedType = 'application/zip';
                              const allowedExtensions = ['.zip'];
                              const maxSize = 100 * 1024 * 1024; // 5MB
                              const fileExtension = file.name
                                .toLowerCase()
                                .slice(file.name.lastIndexOf('.'));

                              if (
                                file.type !== allowedType &&
                                !allowedExtensions.includes(fileExtension)
                              ) {
                                setAddData((prev) => ({
                                  ...prev,
                                  file: null,
                                  file_err: 'Only ZIP files are allowed',
                                }));
                                toast.error(
                                  'Only ZIP files are allowed for Location-Based AR (VPS)'
                                );
                                return;
                              }

                              if (file.size > maxSize) {
                                setAddData((prev) => ({
                                  ...prev,
                                  file: null,
                                  file_err: 'File size must be less than 100MB',
                                }));
                                toast.error('File size must be less than 100MB');
                                return;
                              }

                              // File is valid, update state
                              setAddData((prev) => ({
                                ...prev,
                                file: file,
                                file_err: '',
                              }));
                            }
                          }}
                        />
                      </>
                    )}

                    {/* Image Target UI - remains unchanged */}
                    {title === 'Image Target' && (
                      <>
                        {/* Title */}
                        <h3 className="text-white text-[14px] font-semibold mb-2">
                          Upload a Marker
                        </h3>

                        {/* Icon */}
                        <div className="mb-2">
                          <img
                            src={imagetarget?.type4}
                            alt="Upload Icon"
                            className="w-20 h-20 object-contain"
                          />
                        </div>

                        {/* Description */}
                        <p className="text-white text-[10px] mb-4 text-center">
                          Upload an asset or drag & drop it here.
                        </p>

                        {/* Show info message by default and red error message if error for Image Target */}
                        <div className="text-xs mt-1 w-full px-1 flex flex-col text-center">
                          {!addData?.file ? (
                            <span className="text-gray-400">
                              Images should be in the format: JPG, PNG or JPEG
                              (Maximum file size: 2.25MB)
                            </span>
                          ) : addData?.file?.size > 2.25 * 1024 * 1024 ? (
                            <span className="text-red-500">
                              Maximum file size should be 2.25MB
                            </span>
                          ) : !['image/jpeg', 'image/png', 'image/jpg'].includes(
                            addData?.file?.type
                          ) ? (
                            <span className="text-red-500">
                              File format should be JPG, PNG or JPEG
                            </span>
                          ) : (
                            <span className="text-gray-400">
                              Selected file: {addData?.file?.name}
                            </span>
                          )}
                          {addData?.file_err && (
                            <span className="text-red-500 mt-1">
                              {addData.file_err}
                            </span>
                          )}
                          {addData?.ratingResult && (
                            <div className="mt-3 w-full px-2 flex flex-col items-center gap-2">
                              <span
                                className={
                                  addData.ratingResult.success_Status
                                    ? 'text-green-400'
                                    : 'text-red-400'
                                }
                              >
                                Rating: {addData.ratingResult.rating}/5
                                {addData.ratingResult.success_Status
                                  ? ' — Suitable for tracking'
                                  : ' — Not suitable for tracking'}
                              </span>
                              {(addData.ratingResult.grayImagePath ||
                                addData.ratingResult.featureImagePath) && (
                                  <div className="flex gap-2 justify-center flex-wrap">
                                    {addData.ratingResult.grayImagePath && (
                                      <div className="flex flex-col items-center gap-1">
                                        <span className="text-[10px] text-gray-400">
                                          Grayscale
                                        </span>
                                        <img
                                          src={addData.ratingResult.grayImagePath}
                                          alt="Grayscale analysis"
                                          className="max-h-24 max-w-[120px] rounded border border-[#4A4A50] object-contain bg-[#1a1c20]"
                                        />
                                      </div>
                                    )}
                                    {addData.ratingResult.featureImagePath && (
                                      <div className="flex flex-col items-center gap-1">
                                        <span className="text-[10px] text-gray-400">
                                          Features
                                        </span>
                                        <img
                                          src={
                                            addData.ratingResult.featureImagePath
                                          }
                                          alt="Feature analysis"
                                          className="max-h-24 max-w-[120px] rounded border border-[#4A4A50] object-contain bg-[#1a1c20]"
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                            </div>
                          )}
                        </div>

                        <p className="text-[#CBCBCB] text-[12px] text-center">
                          <span className="underline">
                            (Ensure it is a Quality Marker)
                          </span>
                          <span className="inline-flex items-center justify-center w-4 h-4 ml-1 bg-gray-600 text-white text-xs rounded-full">
                            i
                          </span>
                        </p>

                        {/* FileUploader */}
                        <FileUploader
                          id="file-upload-input"
                          disabled={loading}
                          filename={addData?.file?.name}
                          label={
                            <span className="block text-left px-1 w-full">
                              Upload an Image
                            </span>
                          }
                          accept={{ 'image/*': ['.png', '.jpg', '.jpeg'] }}
                          onFileSelect={async (file) => {
                            // Only validate for Image Target
                            if (file) {
                              const allowedTypes = [
                                'image/jpeg',
                                'image/png',
                                'image/jpg',
                              ];
                              const maxSize = 2.25 * 1024 * 1024; // 2.25MB
                              if (
                                !allowedTypes.includes(file.type) ||
                                !/\.(jpe?g|png)$/i.test(file.name)
                              ) {
                                setAddData((prev) => ({
                                  ...prev,
                                  file: null,
                                  file_err:
                                    'File format must be JPEG, JPG, or PNG',
                                }));
                                toast.error(
                                  'File format must be JPEG, JPG, or PNG'
                                );
                                return;
                              }
                              if (file.size > maxSize) {
                                setAddData((prev) => ({
                                  ...prev,
                                  file: null,
                                  file_err: 'File size must be less than 2.25MB',
                                }));
                                toast.error('File size must be less than 2.25MB');
                                return;
                              }
                            }
                            setAddData((prev) => ({
                              ...prev,
                              file,
                              file_err: '',
                              ratingResult: undefined,
                            }));
                            if (file) {
                              // Show loading toast
                              const loadingToastId = toast.loading(
                                'Rating image, please wait...'
                              );
                              const formData = new FormData();
                              formData.append('file', file);
                              let timeoutId;
                              try {
                                // Set a timeout for the API call (15 seconds)
                                const timeoutPromise = new Promise(
                                  (_, reject) => {
                                    timeoutId = setTimeout(
                                      () =>
                                        reject(
                                          new Error('Image rating API timed out')
                                        ),
                                      15000
                                    );
                                  }
                                );
                                const res = await Promise.race([
                                  axios.post(
                                    'https://imagerating.spatialgrid.ai/imageTarget_rating',
                                    formData,
                                    {
                                      maxBodyLength: Infinity,
                                      headers: {
                                        'Content-Type': 'multipart/form-data',
                                      },
                                    }
                                  ),
                                  timeoutPromise,
                                ]);
                                clearTimeout(timeoutId);
                                const data = res.data;
                                const ratingSucceeded =
                                  typeof data?.Rating === 'number' &&
                                  data?.uploadStatus !== 'Failed';
                                setAddData((prev) => ({
                                  ...prev,
                                  ratingResult: {
                                    ...data,
                                    success_Status: ratingSucceeded,
                                  },
                                }));
                                toast.dismiss(loadingToastId);
                                if (ratingSucceeded) {
                                  toast.success(
                                    data.Rating > 3
                                      ? 'Suitable for image tracking.'
                                      : 'The image cannot be tracked properly and is not suitable for image tracking.'
                                  );
                                } else {
                                  toast.error(
                                    'The image cannot be tracked properly and is not suitable for image tracking.'
                                  );
                                }
                              } catch (err) {
                                clearTimeout(timeoutId);
                                toast.dismiss(loadingToastId);
                                console.error('Image rating API error:', err);
                                setAddData((prev) => ({
                                  ...prev,
                                  ratingResult: { success_Status: false },
                                  file_err:
                                    err.message === 'Image rating API timed out'
                                      ? 'Image rating API timed out. Please try again.'
                                      : 'Image rating failed.',
                                }));
                                toast.error(
                                  err.message === 'Image rating API timed out'
                                    ? 'Image rating API timed out. Please try again.'
                                    : 'Image rating failed.'
                                );
                              }
                            }
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
            </div>
            <div className="flex justify-end pt-10 pb-2 pr-2">
              <div className="flex gap-3">
                <ButtonComponent
                  ref={cancelButtonRef}
                  onClick={() => {
                    setIsVisible(false);
                    setAddData({});
                  }}
                  className="bg-transparent !h-[39px] flex items-center justify-center text-white px-4 gap-3 rounded-[3px] text-nowrap min-w-[140px]  max-w-[100px] hover:bg-transparent font-bold focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-40 focus:ring-offset-1 focus:ring-offset-[#131418]"
                >
                  Cancel
                </ButtonComponent>
                <ButtonComponent
                  ref={startButtonRef}
                  loading={loading}
                  onClick={add_project}
                  className={`bg-[#EE2B2A] !h-[39px] flex items-center justify-center text-white px-4 gap-3 rounded-[3px] text-nowrap min-w-[140px]  max-w-[100px] font-bold focus:outline-none focus:ring-2 focus:ring-[#ee2b2a] focus:ring-offset-1 focus:ring-offset-[#131418] ${title === 'Image Target' && !addData?.ratingResult?.success_Status ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#EE2B2A]'} `}
                  disabled={
                    title === 'Image Target' &&
                    (!addData?.file ||
                      !addData?.ratingResult?.success_Status)
                  }
                >
                  Start Project
                </ButtonComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export const Brodcrumb = React.memo(({ data }) => {
  const navigate = useNavigate();
  return (
    <div className="">
      <div className="hidden sm:block ">
        {Object.keys(data)?.length > 0 && (
          <p
            className={`flex gap-2 text-[14px] text-[#D9D9D9] ${data?.mt ? data?.mt : ''
              } `}
          >
            {data?.item?.map((v, i) => (
              <span
                className="cursor-pointer  flex gap-2 items-center "
                key={i}
                onClick={() => navigate(v?.path)}
              >
                {/* {v?.name} <FaChevronRight size={16} className="font-light" /> */}
                {v?.name} <img src={iconsPath?.rightIcon} alt="Right Icon" />
              </span>
            ))}
            <span className="font-light"> {data.name}</span>
          </p>
        )}
      </div>
      <div>
        <BackButton />
      </div>
    </div>
  );
});

export const BackButton = React.memo(
  ({ className = 'flex sm:hidden', icon }) => {
    const navigate = useNavigate();
    return (
      <div
        className={`${className} gap-2 justify-start items-center cursor-pointer`}
        onClick={() => navigate(-1)}
      >
        {/* {icon ? icon : <FaArrowLeftLong size={20} />} */}
        {icon ? icon : <img src={iconsPath?.leftIcon} alt="Left Icon" />}
        Back
      </div>
    );
  }
);

export const FileUploader = ({
  onFileSelect,
  filename,
  error,
  disabled,
  label,
  accept,
  fullAreaClick, // 👈 new optional prop
  isVps = false,
}) => {
  var errorData = error;

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles?.length > 1) {
        toast.error('We accept only one file at a time');
        errorData = 'We accept only one file at a time';
      } else if (onFileSelect && acceptedFiles.length > 0) {
        onFileSelect(acceptedFiles[0]); // Only take the first file
      }
    },
    [onFileSelect]
  );

  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop,
    accept: accept,
    noClick: !!fullAreaClick, // 👈 disables internal click if we handle it outside
  });

  // 👇 if parent wants to control full-area click
  useEffect(() => {
    if (fullAreaClick) {
      fullAreaClick.current = open;
    }
  }, [fullAreaClick, open]);

  return (
    <div
      {...getRootProps()}
      className="w-full flex flex-col justify-center items-center text-center pt-4 cursor-pointer"
    >
      <input disabled={disabled} {...getInputProps()} />
      {isDragActive ? (
        <p className="text-white">
          {accept && accept['image/*']
            ? 'Drop the image here...'
            : 'Drop the .zip file here...'}
        </p>
      ) : (
        <>
          {/* 👇 show label only if NOT VPS */}
          {
            <p className={`${errorData ? 'text-red-600' : 'text-white'}`}>
              {label || 'Upload an Asset'}
            </p>
          }

          {filename && <p>Selected File : {filename}</p>}
        </>
      )}
      {errorData && (
        <span className="text-red-400 max-w-[200px]">{errorData}</span>
      )}
    </div>
  );
};

export const ModalDefaultComponent = React.memo(({ children, closeModal }) => {
  const modalRef = useRef(null);
  useClickOutside(modalRef, () => {
    closeModal();
  });
  return (
    <div
      ref={modalRef}
      className="flex justify-center items-center border border-[#444447] min-w-screen rounded-[10px] min-w-[500px] py-6 px-8 bg-[#1E1F22] overflow-hidden "
    >
      <div className="   rounded-lg  min-w-full md:min-w-[350px] max-w-[350px] justify-center items-center mr-auto ml-auto flex flex-col gap-2 min-h-[140px] h-auto w-full py-2">
        {children}
      </div>
    </div>
  );
});
